import React, { useMemo } from "react";
import { Link, useLocation } from "react-router-dom";
import Loader from "../../components/Loader";
import InnerBannerBreadcrumb from "../../components/shared/breadcrumb/InnerBannerBreadcrumb";
import { useLanguageTranslation } from "../../hooks/useLanguageTranslation";
import { useSelector } from "react-redux";
import { useGetProtectedApiDataQuery } from "../../redux/services/apiSlice";
import {
  convertSymbolCodes,
  extractDateFromStr,
  getLatestUpdatedObject,
} from "../../Utils/utils";
import PageLastUpdated from "../../components/shared/PageLastUpdated";
import { useTableResponsive } from "../../hooks/useTableResponsive";
import PdfZipItem from "../../components/PdfZipItem";
import useSeo from "../../hooks/useSeo";

const MseStartups = () => {
  const { languageType } = useSelector((state) => state.homeSlice);
  const { pathname } = useLocation();
  const { innerBannerImage, innerBannerTitle } = useSeo({ pathname });
  const {
    data: tableData = [],
    error: tableError,
    isLoading: tableIsloading,
  } = useGetProtectedApiDataQuery({ url: "mse_startups", lang: languageType });

  useTableResponsive(tableData);
  const { getText } = useLanguageTranslation();

  const lastUpdatedOn = useMemo(() => {
    return extractDateFromStr(getLatestUpdatedObject(tableData)?.changed);
  }, [tableData]);

  if (tableError) {
    return <p>Error loading table data: {tableError.message}</p>;
  }
  if (tableIsloading) {
    return <Loader />;
  }
  return (
    <>
      <InnerBannerBreadcrumb
        titleLink="/mse-startups"
        levelTwo={false}
        levelThree={false}
        bannerImage={innerBannerImage}
        title={convertSymbolCodes(innerBannerTitle)}
        isActive={convertSymbolCodes(innerBannerTitle)}
      />
      <div className="inner-container">
        <div className="container">
          <div className="container">
            <PageLastUpdated lastUpdatedOn={lastUpdatedOn} />
            <div className="row">
              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                <div className="title-sec">
                  {/* <h4>MSE & Startups</h4> */}
                  <div className="table-responsive mb-5">
                    <table className="table table-striped custom-table">
                      <thead className="thead-dark">
                        <tr>
                          <th> {getText("S.No.", "क्र. सं.")}</th>
                          <th>{getText("Description", "विवरण")}</th>
                          <th>{getText("Download", "डाउनलोड")}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {tableData.map((item, index) => (
                          <tr key={index}>
                            <td data-key={getText("S.No.", "क्र. सं.")}>
                              {index + 1}
                            </td>
                            <td data-key={getText("Description", "विवरण")}>
                              {item.title}
                            </td>
                            <td data-key={getText("Download", "डाउनलोड")}>
                              {item.field_download ? (
                                <PdfZipItem
                                  filePath={item?.field_download}
                                  filesize={item?.filesize}
                                />
                              ) : (
                                <>
                                  <Link
                                    to={`/mse-startups/${item.nid}`}
                                    className="division-pdf-icon"
                                  >
                                    <span className="date">
                                      {getText("Details", "विवरण")}
                                    </span>
                                  </Link>
                                </>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MseStartups;
